<template>
  <div id='bd-kb-article-list'>
    <span>文章列表</span>
    <div class="thread-search">
      <el-input
        style="width: 80%;"
        size="mini"
        :placeholder="searchTip"
        v-model="search"
        @keyup.enter.native="onKeyUp"
        clearable
      ></el-input>
      <el-button style="float: right;" size="mini" icon="el-icon-search" @click="doSearch" circle></el-button>
    </div>
    <div>
      <el-button v-if="isCreateVisible" size="mini" @click="createNewArticle">创建</el-button>
      <el-button v-if="isDeleteVisible" size="mini" @click="doDelete">删除</el-button>
    </div>
    <div style="height: calc(100% - 60px); overflow-y: auto;">
      <li v-for="article in articles.content"
        :key="article.aid"
        class="list-item"
        :class="{ ' active': article.aid === currentArticle.aid }"
        @click.exact="selectArticle(article)"
        @click.right="rightEvent(article)">
        <div class="list-right">
          <div class="top">
            <span class="nickname">{{ article.title }}</span>
            <span class="timestamp">
              {{ article.updatedAt | time }}
            </span>
          </div>
          <div class="bottom">
            <span class="content">
              {{ article.summary }}
              <!-- <li v-if="category in article.categories" :key="category.cid">
                <el-tag>{{ category.name }}</el-tag>
              </li> -->
            </span>
          </div>
          <!-- <hr/> -->
        </div>
      </li>
      <el-empty
        v-if="articles.content.length === 0"
        description="无文章"
      ></el-empty>
      <el-pagination
        :page-size="pageSize"
        :pager-count="5"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-count="articles.totalPages"
        :total="articles.totalElements"
        :hide-on-single-page="true"
        layout="prev, pager, next"
      >
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import * as https from '@/apis/http'
// import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-kb-article-list',
  data () {
    return {
      search: '',
      //
      currentPage: 1,
      pageSize: 10,
      //
      article: {
        id: 0,
        title: '',
        recommend: false,
        published: false,
        categories: [],
        summary: '',
        markdown: false,
        content: '',
        attachments: [],
        type: constants.CATEGORY_TYPE_SUPPORT
      },
    }
  },
  computed: {
    ...mapGetters("knowledgebase", ['articles', 'currentArticle', 'currentCategory']),
    isCreateVisible() {
      return this.currentCategory.id !== 0
    },
    isDeleteVisible() {
      return this.currentArticle.aid !== '' && this.articles.content.length > 0
    },
    searchTip() {
      return this.$t("search");
    },
  },
  watch: {
    search(newValue, oldValue) {
      console.log('search:', newValue, oldValue)
      if (newValue === '') {
        let payload2 = { categoryId: this.currentCategory.id, page: 0, size: this.pageSize }
        this.getArticlesSupport(payload2)
      }
    }
  },
  methods: {
    ...mapActions("knowledgebase", ['createArticle', 'updateArticle', 'deleteArticle', 'filterArticle', 'updateCurrentArticle', 'getArticlesSupport']),
    createNewArticle() {
      //
      let categories = []
      if (this.currentCategory.id !== 0) {
        categories = [this.currentCategory.id]
      }
      //
      let article = {
        title: '新文章标题',
        recommend: true,
        published: true,
        categories: categories,
        summary: '',
        markdown: false,
        content: '新文章内容',
        attachments: [],
        type: constants.CATEGORY_TYPE_SUPPORT
      }
      // console.log('article:', article)
      this.createArticle(article)
    },
    doDelete() {
      console.log('currentArticle: ', this.currentArticle)
      //
      this.$confirm(this.$t("deleteASure"), this.$t("tip"), {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      })
      .then(() => {
        this.deleteArticle(this.currentArticle.id)
      })
      .catch(() => {});
    },
    selectArticle(article) {
      // console.log('selectArticle:', article)
      // TODO: 对比是否有变动，如有变动则保存
      this.updateCurrentArticle(article)
    },
    rightEvent(article) {
      console.log('rightEvent：', article)
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      // 加载
      let payload = { categoryId: this.currentCategory.id, page: this.currentPage - 1, size: this.pageSize };
      this.getArticlesSupport(payload);
    },
    onKeyUp() {
      // console.log('onKeyUp:')
      this.doSearch()
    },
    doSearch() {
      // console.log('doSearch:')
      let payload = { page: 0, size: this.pageSize, content: this.search }
      this.filterArticle(payload)
    },
  },
  created () {
    //
  },
  mounted() {
    
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time (value) {
      if (typeof value === 'string') {
        return moment(value).format('MM-DD HH:mm:ss')
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
#bd-kb-article-list {
  width: 100%;
  height: 100%;
  float: left;
}
#bd-kb-article-list .thread-search {
  padding: 12px 12px 12px 12px;
}
#bd-kb-article-list .list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  /* height: 50px; */
  height: auto;
}
#bd-kb-article-list .list-item:hover {
  background-color: rgb(220, 220, 220);
}
.active {
  background-color: darkkhaki;
}
#bd-kb-article-list .list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
#bd-kb-article-list li {
  list-style: none;
}
#bd-kb-article-list .list-right {
  margin-left: 5px;
}
#bd-kb-article-list .list-right .top {
  margin-top: 2px;
  text-align: left;
}
#bd-kb-article-list .list-right-ticket {
  margin-left: 5px;
}
#bd-kb-article-list .list-right-ticket .top {
  margin-top: 2px;
  text-align: left;
}
#bd-kb-article-list span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#bd-kb-article-list span.timestamp {
  float: right;
  color: gray;
  font-size: 12px;
  vertical-align: top;
  width: 88px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#bd-kb-article-list .list-right .bottom {
  text-align: left;
}
#bd-kb-article-list .list-right-ticket .bottom {
  text-align: left;
}
#bd-kb-article-list .list-right .bottom-queue {
  width: 90%;
  text-align: left;
}
#bd-kb-article-list .list-right .bottom .content {
  display: inline-block;
  vertical-align: top;
  font-size: 12px;
  color: gray;
  width: calc(100% - 25px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#bd-kb-article-list .list-right .bottom .star {
  font-size: 14px;
  float: right;
}
#bd-kb-article-list .list-right .unreadCount {
  margin-top: 4px;
  float: right;
  font-size: 10px;
  width: 12px;
  height: 12px;
  line-height: 12px;
  text-align: center;
  border-radius: 5px;
  color: white;
  background-color: red;
}
</style>
